import React, { memo, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { TILE_CHARACTERS } from '../utils/constants';

const Tile = memo(({ value, r, c, isMerged, isNew }) => {
  const [cellSize, setCellSize] = useState(70);
  const [cellGap, setCellGap] = useState(6);
  const [gridPadding, setGridPadding] = useState(10);

  useEffect(() => {
    const updateSizes = () => {
      const root = document.documentElement;
      const computedStyle = getComputedStyle(root);
      
      const size = parseInt(computedStyle.getPropertyValue('--cell-size')) || 70;
      const gap = parseInt(computedStyle.getPropertyValue('--cell-gap')) || 6;
      const padding = parseInt(computedStyle.getPropertyValue('--grid-padding')) || 10;
      
      setCellSize(size);
      setCellGap(gap);
      setGridPadding(padding);
    };

    updateSizes();
    window.addEventListener('resize', updateSizes);
    return () => window.removeEventListener('resize', updateSizes);
  }, []);

  const x = c * (cellSize + cellGap) + gridPadding;
  const y = r * (cellSize + cellGap) + gridPadding;

  const getAnimationClass = (val) => {
    if (val <= 8) return 'animate-jump';
    if (val <= 64) return 'animate-wiggle';
    return '';
  };

  // 🎯 專業合成動畫：同時放大 + 旋轉 + 彈跳
  const mergeAnimation = isMerged ? {
    scale: [1, 1.25, 1],
    rotate: [0, 5, -5, 0],
    transition: {
      duration: 0.4,
      ease: [0.34, 1.56, 0.64, 1], // Custom bounce easing
    }
  } : {};

  // 🎯 專業新方塊動畫：延遲 + 彈出 + 微旋轉
  const newTileAnimation = isNew ? {
    scale: [0, 1.15, 0.95, 1],
    rotate: [0, 10, -5, 0],
    opacity: [0, 1],
    transition: {
      delay: 0.1, // 延遲讓玩家先看到合成動畫
      duration: 0.5,
      ease: [0.68, -0.55, 0.27, 1.55], // Elastic bounce
    }
  } : {};

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ 
        x, 
        y, 
        scale: 1, 
        opacity: 1,
        ...mergeAnimation,
        ...newTileAnimation
      }}
      exit={{ 
        scale: 0.8,
        opacity: 0,
        transition: { duration: 0.2, ease: "easeIn" }
      }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
        mass: 0.6
      }}
      className={`absolute flex flex-col justify-center items-center shadow-md select-none tile-${value} ${isMerged ? 'z-50' : ''}`}
      style={{
        width: cellSize,
        height: cellSize,
        borderRadius: cellSize > 80 ? '12px' : '10px',
        zIndex: isMerged ? 100 : value,
        top: 0,
        left: 0,
        willChange: 'transform'
      }}
    >
      <div className={`text-xl sm:text-3xl lg:text-4xl mb-0.5 ${getAnimationClass(value)}`}>
        {TILE_CHARACTERS[value] || "🔮"}
      </div>
      <div className="text-[9px] sm:text-[10px] lg:text-xs font-black opacity-60">
        {value}
      </div>
    </motion.div>
  );
});

export default Tile;